import { render, staticRenderFns } from "./NLPResultView.vue?vue&type=template&id=035a4bc6&"
import script from "./NLPResultView.vue?vue&type=script&lang=js&"
export * from "./NLPResultView.vue?vue&type=script&lang=js&"
import style0 from "./NLPResultView.vue?vue&type=style&index=0&id=035a4bc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports